import { FolderIllustration } from '@carboncopyco/illustrations';
import { EmptyView, TextBase } from '@carboncopyco/ui';

export const FolderPageEmptyState = () => {
  return (
    <EmptyView
      illustration={<FolderIllustration />}
      title="Empty folder"
      message={
        <div className="flex flex-col items-center">
          <TextBase
            label="Waiting for assets to be added."
            color="text-ds-natural-400"
          />
        </div>
      }
    />
  );
};
